module.exports = __webpack_public_path__ + "ba5dfaf939e0d000186cf2f522d1412e.gif";


//////////////////
// WEBPACK FOOTER
// ./ramastangifs/Ramban002loop.gif
// module id = 58
// module chunks = 4